/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateInstructionFeedbackDto
 */
export interface UpdateInstructionFeedbackDto {
    /**
     * Feedback for the instruction generation output
     * @type {string}
     * @memberof UpdateInstructionFeedbackDto
     */
    feedback: string;
}

/**
 * Check if a given object implements the UpdateInstructionFeedbackDto interface.
 */
export function instanceOfUpdateInstructionFeedbackDto(value: object): value is UpdateInstructionFeedbackDto {
    if (!('feedback' in value) || value['feedback'] === undefined) return false;
    return true;
}

export function UpdateInstructionFeedbackDtoFromJSON(json: any): UpdateInstructionFeedbackDto {
    return UpdateInstructionFeedbackDtoFromJSONTyped(json, false);
}

export function UpdateInstructionFeedbackDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateInstructionFeedbackDto {
    if (json == null) {
        return json;
    }
    return {
        
        'feedback': json['feedback'],
    };
}

export function UpdateInstructionFeedbackDtoToJSON(json: any): UpdateInstructionFeedbackDto {
    return UpdateInstructionFeedbackDtoToJSONTyped(json, false);
}

export function UpdateInstructionFeedbackDtoToJSONTyped(value?: UpdateInstructionFeedbackDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'feedback': value['feedback'],
    };
}

